<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Candidates') }}</h4>
        </div>
        <div class="btn-row">
          <JobMassiveAction
            v-if="selected.length"
            :jobActions="false" />

          <button
            v-if="permissions.includes('manage_candidates')"
            type="button"
            class="btn btn-primary"
            @click="showCreateModal()">
            + {{ $t('New candidate') }}
            </button>
        </div>
      </div>

    </div>

    <div class="vflex-row-1">
      
      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <table class="table table-hover">
              <thead class="table-thead-sticky">
                <tr>
                  <th
                    class="text-truncate"
                    width="30"><input type="checkbox" @click="toggleCheckAll" :checked="checkedAll"></th>
                  <th
                    class="text-truncate"
                    width="30"></th>
                  <th-sort
                    field="name"
                    :value="sort"
                    @input="setSort">{{ $t('Name') }}</th-sort>
                  <th-sort
                    field="city"
                    :value="sort"
                    @input="setSort">{{ $t('Location') }}</th-sort>
                  <th-sort
                    field="city"
                    :value="sort"
                    @input="setSort">{{ $t('Qualifications summary') }}</th-sort>
                  <th-sort
                    field="avg_rating.evaluation"
                    :value="sort"
                    @input="setSort">{{ $t('Evaluation') }}</th-sort>
                  <th-sort
                    v-if="gdprEnable"
                    field="gdpr.conset_status"
                    :value="sort"
                    @input="setSort">{{ $t('GDPR') }}</th-sort>
                  <th-sort
                    field="created_at"
                    :value="sort"
                    @input="setSort">{{ $t('Created at') }}</th-sort>
                </tr>
              </thead>
              <tbody>
                <candidate-list-item
                  v-for="(candidate, index) in candidates"
                  :key="index"
                  :candidate="candidate"
                  :keywords="filters.text">
                  </candidate-list-item>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>
      
      </filterfy>

    </div>

    <div 
      class="vflex-row-0"
      v-if="modal_create_select">
      <candidate-create-form 
        :initCandidate="modal_create_select"
        @hideModal="hideCreateModal()" 
        @saved="createdCandidate">
        </candidate-create-form>
    </div>
    
  </div>

</template>

<script>
import CandidateCreateForm from '@/components/CandidateCreateForm/CandidateCreateForm'
import Filterfy from '@/components/Filterfy/Filterfy'
import CandidateListItem from './CandidateListItem'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import JobMassiveAction from '@/components/Job/JobMassiveAction/JobMassiveAction'

export default {
  name: 'CandidateList',
  components: {
    Filterfy,
    CandidateCreateForm,
    CandidateListItem,
    ThSort,
    Paginaty,
    JobMassiveAction
  },
  data () {
    const account = this.$store.getters.getAccount
    const gdprEnable = account.settings.gdpr

    return {
      creating: true,
      loading: true,
      modal_create_select: false,
      filtersMap: [
        {
          'type': 'fulltext',
          'label': this.$t('Keywords'),
          'target': 'text'
        },
        {
          'type': 'keyword',
          'label': this.$t('City'),
          'target': 'city'
        },
        ...(gdprEnable ? [{
          'type': 'list',
          'label': this.$t('GDPR Compliance'),
          'target': 'gdpr.consent_status',
          'resource': 'gpdr_status'
        }] : []),
        {
          'type': 'slider-range',
          'label': this.$t('Evaluation'),
          'target': 'avg_rating.evaluation',
          'min': 0,
          'max': 100,
          'interval': 25,
          'format': '{value}%'
        },
        {
          'type': 'list',
          'label': 'Tags',
          'target': 'tags',
          'resource': 'candidate-tags'
        },
        {
          'type': 'list',
          'label': 'Tags (E)',
          'target': 'tags.and',
          'resource': 'candidate-tags'
        },
        {
          'type': 'list',
          'label': this.$t('Experience level'),
          'target': 'experience_level',
          'resource': 'experience_level'
        },
        {
          'type': 'list',
          'label': this.$t('Education degree'),
          'target': 'educations.education_degree',
          'resource': 'education_degree'
        },
        {
          'type': 'slider-range',
          'label': this.$t('Salary'),
          'target': 'salary',
          'min': 0,
          'max': 50000,
          'interval': 1000,
          'format': '$ {value}'
        },
        {
          'type': 'slider-range-years',
          'label': this.$t('Age'),
          'target': 'birth_date',
          'min': 0,
          'max': 100,
          'interval': 1,
          'format': '{value}'
        },
        {
          'type': 'list',
          'label': this.$t('Languages'),
          'target': 'languages.language',
          'resource': 'languages'
        },
        {
          'type': 'list',
          'label': this.$t('Disability'),
          'target': 'disability',
          'resource': 'disabilities'
        },
        {
          'type': 'list',
          'label': this.$t('Gender'),
          'target': 'gender',
          'resource': 'genders'
        },
        {
          'type': 'list',
          'label': this.$t('Origin'),
          'target': 'origin',
          'resource': 'origins'
        }
      ]
    }
  },
  computed: {
    gdprEnable () {
      const account = this.$store.getters.getAccount
      return account.settings.gdpr
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidates () {
      return this.$store.getters.getCandidates
    },
    paginate () {
      return this.$store.getters.getCandidatesPaginate
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-created_at'
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    },
    checkedAll () {
      return this.selected.length && !this.candidates.find(v => !this.selected.includes(v._id))
    }
  },
  metaInfo () {
    return {
      title: this.$t('Candidates')
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        page: this.$route.query.page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectCandidates', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.setPage(1)
        this.pages = result.pages
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam({
        ...filters,
        sort: filters.text ? '-score' : undefined
      })
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    /*
    showCandidate
    */
    showCandidateModal (id) {
      this.$changeUrlParam({
        candidate_id: id
      })
    },
    /*
    createCandidate
    */
    showCreateModal () {
      this.modal_create_select = {}
    },
    hideCreateModal () {
      this.modal_create_select = false
    },
    createdCandidate (data) {
      this.hideCreateModal()
      this.$store.dispatch('refreshSelectCandidates')
      this.showCandidateModal(data._id)
    },
    /*
    toogleCheckAll
    */
    toggleCheckAll () {
      const checkedAll = this.checkedAll
      this.candidates.forEach((candidate) => {
        const action = checkedAll ? 'removeCandidateSelected' : 'addCandidateSelected'
        this.$store.dispatch(action, candidate._id)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CandidateList/CandidateList.vue